import { render, staticRenderFns } from "./audiosearch.vue?vue&type=template&id=cce1472c&"
import script from "./audiosearch.vue?vue&type=script&lang=js&"
export * from "./audiosearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchLandingPage: require('/opt/render/project/src/channels2022/src/components/search-lp/SearchLandingPage.vue').default})
